// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"664":"720c2a17","3213":"40bf7f71","5977":"2f6c0109","5995":"54b1e827","6150":"c8c246c2","6595":"98f8e577","7571":"95370f0c","9699":"1758b920"}[chunkId] + ".chunk.css";
};